import React from 'react'
import { FaSpinner } from 'react-icons/fa'

import './styles.scss'

export function Loading() {
  return <FaSpinner className='spinner' />
}
